import { Controller } from '@hotwired/stimulus';

// Adapts an independent, read-only selector to one statement's value store.
export default class extends Controller {
  static targets = ['values', 'frame', 'summary', 'missing', 'error'];
  static values = { url: String };

  connect() {
    this.frameTarget.id = `automation_conditions_${crypto.randomUUID()}`;
    this.refresh();
    this.load();
  }

  load() {
    this.errorTarget.hidden = true;
    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set('frame_id', this.frameTarget.id);
    for (const option of [...this.valuesTarget.selectedOptions]) {
      if (option.dataset.conditionId) url.searchParams.append('selected_ids[]', option.dataset.conditionId);
    }
    if (this.frameTarget.src === url.href) this.frameTarget.reload();
    else this.frameTarget.src = url.href;
  }

  failed(event) {
    event.preventDefault();
    this.errorTarget.hidden = false;
  }

  changed(event) {
    // Missing references stay visible until deliberately removed by the user.
    const selected = new Set(event.detail.values);
    // Choices can be added to the campaign after the parent form was loaded.
    for (const { value, label } of event.detail.options || []) {
      if ([...this.valuesTarget.options].some(option => option.dataset.conditionId === value)) continue;
      const option = new Option(label, `status_condition_${value}`);
      option.dataset.conditionId = value;
      option.dataset.ruleValue = JSON.stringify({ var: `status_conditions.status_condition_${value}.id` });
      this.valuesTarget.add(option);
    }
    for (const option of this.valuesTarget.options) {
      if (option.dataset.conditionId) option.selected = selected.has(option.dataset.conditionId);
    }
    this.refresh();
    this.valuesTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }

  removeMissing() {
    for (const option of [...this.valuesTarget.selectedOptions]) {
      if (!option.dataset.conditionId) option.selected = false;
    }
    this.refresh();
    this.valuesTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }

  refresh() {
    const selected = [...this.valuesTarget.selectedOptions];
    this.summaryTarget.textContent = selected.length ? selected.map(option => option.textContent).join(', ') : 'Choose conditions';
    this.missingTarget.hidden = !selected.some(option => !option.dataset.conditionId);
  }
}
